import { render, staticRenderFns } from "./RankingModal.vue?vue&type=template&id=0c24506a&scoped=true"
import script from "./RankingModal.vue?vue&type=script&lang=js"
export * from "./RankingModal.vue?vue&type=script&lang=js"
import style0 from "./RankingModal.vue?vue&type=style&index=0&id=0c24506a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c24506a",
  null
  
)

export default component.exports